export default "__VITE_ASSET__Cj1eg$wd__"